/*------------------------------------*\
    Email Validation
\*------------------------------------*/
class EmailValidation {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let emailValidation = document.getElementById('emailValidate');

        emailValidation.addEventListener('click', (evt) => {
            evt.preventDefault();

            self.validateFirstName();
            self.validateLastName();
            self.validatePostcode();
            self.validateEmail();
        });
    }

    validateEmail() {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        var inputText = document.getElementById("email").value.trim();

        if(inputText === '') {
            if(inputText.match(mailformat)) {
                return true;
            } else {
                document.getElementById('email-feedback').classList.add('d-block');
                document.getElementById('email').classList.add('is-invalid');

                return false;
            }
        } else {
            document.getElementById('email-feedback').classList.remove('d-block');
            document.getElementById('email').classList.remove('is-invalid');

            return true
        }
    }

    validateFirstName() {
        var inputText = document.getElementById("first_name").value.trim();

        if(inputText === '') {
            document.getElementById('firstname-feedback').classList.add('d-block');
            document.getElementById('first_name').classList.add('is-invalid');

            return false;
        } else {
            document.getElementById('firstname-feedback').classList.remove('d-block');
            document.getElementById('first_name').classList.remove('is-invalid');

            return true
        }
    }

    validateLastName() {
        var inputText = document.getElementById("last_name").value.trim();

        if(inputText === '') {
            document.getElementById('lastname-feedback').classList.add('d-block');
            document.getElementById('last_name').classList.add('is-invalid');
            return false;
        } else {
            document.getElementById('lastname-feedback').classList.remove('d-block');
            document.getElementById('last_name').classList.remove('is-invalid');

            return true
        }
    }

    validatePostcode() {
        var inputText = document.getElementById("postcode").value.trim();

        if(inputText === '') {
            document.getElementById('postcode-feedback').classList.add('d-block');
            document.getElementById('postcode').classList.add('is-invalid');
            return false;
        }  else {
            document.getElementById('postcode-feedback').classList.remove('d-block');
            document.getElementById('postcode').classList.remove('is-invalid');

            return true
        }
    }
}

export default EmailValidation;